import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Button} from "reactstrap"
import {getExportOrdersRoyalMail} from "../../../services/api/apiBarcode"

class ExportRoyalMail extends Component {
    _exportRoyalMail = async () => {
        try {
            const {filter} = this.props

            const query = {
                barcode_gte: filter.barcodeNumber['$gte'],
                barcode_lte: filter.barcodeNumber['$lte'],
                production_statuses: filter.production_status,
                types: [filter['products.type']],
                shipping_carrier: filter.shipping_carrier
            }

            if (filter.barcodeNumber['$gte'] === undefined) {
                return alert('Vui lòng thêm vào giá trị From barcodeNumber, đây là filter bắt buộc khi export Royal Mail.')
            }

            if (filter.barcodeNumber['$lte'] === undefined) {
                delete query.barcode_lte
            }

            if (filter.production_status === undefined) {
                delete query.production_statuses
            }

            if (filter['products.type'] === undefined) {
                delete query.types
            }

            window.location.href = getExportOrdersRoyalMail(query)
        } catch (e) {
            alert(e.message)
        }
    }

    render() {
        return (
            <Button className="btn-labeled btn-labeled-left ml-1" onClick={this._exportRoyalMail} color="primary">
                <b><i className="mi-file-upload"/></b>
                Export By Carrier
            </Button>
        )
    }
}

ExportRoyalMail.propTypes = {
    filter: PropTypes.object.isRequired
}

export default ExportRoyalMail
